export const FQAData = [
  {
    question: "What services do you offer?",
    answer:
      "We offer a range of repair services for electronic devices including laptops, desktops, and accessories. This includes hardware diagnostics, software troubleshooting, replacements, upgrades, and more.",
  },
  {
    question: "How does the pickup and delivery process work?",
    answer:
      "Simply schedule a pickup through our website or call us. Our technician will arrive at your location to collect your laptop, and once repairs are complete, we will deliver it back to you at your convenience.",
  },
  {
    question: "Is there a fee for pickup and delivery?",
    answer:
      "Pickup and delivery are free within our service coverage areas. For locations outside this zone, a minimal fee may apply, which will be communicated at the time of scheduling.",
  },
  {
    question: "How long does the repair process take?",
    answer:
      "Repair timelines depend on the issue and availability of parts. Most common repairs are completed within 2-3 business days. We will provide an estimated timeline after initial diagnosis.",
  },
  {
    question: "How do I pay for the service?",
    answer:
      "You can pay securely online via credit/debit card, UPI, or net banking. Cash on delivery is also available for certain services upon request.",
  },
  {
    question: "Can I track my laptop during the repair process?",
    answer:
      "Yes, once your device is picked up, you can track its status through your account on our website. You’ll also receive email or SMS updates at key stages.",
  },
  {
    question: "Do I get a warranty on the repair service?",
    answer:
      "Yes, all our repairs come with a 30-day service warranty. If the same issue recurs within this period, we’ll fix it at no additional cost.",
  },
  {
    question: "What if I decline the repair after diagnosis?",
    answer:
      "If you choose not to proceed after our technician has diagnosed the issue, a small inspection fee may apply to cover logistics and diagnostic time.",
  },
];
